<p-toast></p-toast>

<!-- Tabela de busca de produtos (abre quando clica na lupa) -->
<div *ngIf="mostrarTabelaBusca" class="ps-tabela-busca ps-tabela-fullheight">

  <!-- Busca global -->
  <div class="ps-busca-global">
    <div class="ps-busca-input-wrapper">
      <i class="pi pi-search ps-busca-icone"></i>
      <input #buscaInput pInputText type="text" class="w-full ps-busca-input" [(ngModel)]="buscaGlobal"
        [placeholder]="'produto-selecionar.placeholders.buscar_em_todos_campos' | translate"
        (input)="onBuscaGlobalChange()" />
    </div>
    <button pButton type="button" icon="pi pi-plus" class="p-button-success ps-criar-btn"
      label="{{ 'produto-selecionar.tooltips.criar_novo_item' | translate }}"
      (click)="abrirDialogCriarItem()"></button>
  </div>

  <!-- Info de registros e paginação superior -->
  <div class="ps-tabela-info">
    <span class="ps-registros-info">
      {{ 'produto-selecionar.texts.pagina' | translate }} {{ paginaAtual + 1 }}/{{ totalPaginas || 1 }}
      <span class="ml-3 text-500">{{ totalRecords }} {{ 'produto-selecionar.texts.registros' | translate }}</span>
    </span>
    <div class="ps-paginacao-top">
      <button pButton icon="pi pi-angle-double-left" class="p-button-text p-button-sm"
        [disabled]="paginaAtual === 0" (click)="irParaPagina(0)"></button>
      <button pButton icon="pi pi-angle-left" class="p-button-text p-button-sm"
        [disabled]="paginaAtual === 0" (click)="irParaPagina(paginaAtual - 1)"></button>
      <button pButton icon="pi pi-angle-right" class="p-button-text p-button-sm"
        [disabled]="paginaAtual >= totalPaginas - 1" (click)="irParaPagina(paginaAtual + 1)"></button>
      <button pButton icon="pi pi-angle-double-right" class="p-button-text p-button-sm"
        [disabled]="paginaAtual >= totalPaginas - 1" (click)="irParaPagina(totalPaginas - 1)"></button>
      <p-dropdown [options]="opcoesLinhasPorPagina" [(ngModel)]="rows3" (onChange)="onLinhasPorPaginaChange()"
        appendTo="body" panelStyleClass="dropdown-panel-above-modal"
        [style]="{ 'min-width': '70px' }"></p-dropdown>
    </div>
  </div>

  <!-- Tabela de itens -->
  <div class="ps-tabela-container">
    <p-table [value]="itens" [loading]="loadingProdutos" selectionMode="single" [(selection)]="itemSelecionadoTabela"
      (onRowSelect)="onRowSelect($event)" [scrollable]="true" scrollHeight="400px"
      [tableStyle]="{ 'min-width': '800px' }" styleClass="p-datatable-sm p-datatable-striped"
      (sortFunction)="customSort($event)" [customSort]="true" dataKey="id">

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 50px; white-space: nowrap">{{ 'produto-selecionar.labels.imagem' | translate }}</th>
          <th pSortableColumn="codigoItem" style="width: 70px; white-space: nowrap">
            {{ 'produto-selecionar.labels.codigo' | translate }}<p-sortIcon field="codigoItem"></p-sortIcon>
          </th>
          <th pSortableColumn="nome" style="white-space: nowrap">
            {{ 'produto-selecionar.labels.nome' | translate }}<p-sortIcon field="nome"></p-sortIcon>
          </th>
          <th pSortableColumn="grupo.nome" style="width: 120px; white-space: nowrap">
            {{ 'produto-selecionar.labels.grupo' | translate }}<p-sortIcon field="grupo.nome"></p-sortIcon>
          </th>
          <th pSortableColumn="subGrupo.nome" style="width: 120px; white-space: nowrap">
            {{ 'produto-selecionar.labels.sub_grupo' | translate }}<p-sortIcon field="subGrupo.nome"></p-sortIcon>
          </th>
          <th pSortableColumn="saldo" style="width: 70px; white-space: nowrap">
            {{ 'produto-selecionar.labels.saldo' | translate }}<p-sortIcon field="saldo"></p-sortIcon>
          </th>
          <th pSortableColumn="custo" style="width: 110px; white-space: nowrap">
            {{ 'produto-selecionar.labels.preco_custo' | translate }}<p-sortIcon field="custo"></p-sortIcon>
          </th>
          <th pSortableColumn="precoDeVenda" style="width: 110px; white-space: nowrap">
            {{ 'produto-selecionar.labels.preco_venda' | translate }}<p-sortIcon field="precoDeVenda"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-produto>
        <tr [pSelectableRow]="produto" [class.row-selecionado]="itemSelecionadoTabela?.id === produto.id"
          (dblclick)="onRowDblClick(produto)">
          <td style="width: 60px">
            <img class="product-image" [src]="env.imgHost + '/' + idEmpresa + '/item/' + produto.imagem"
              [alt]="produto.nome" (error)="onImageError($event)" />
          </td>
          <td style="width: 80px">{{ produto.codigoItem }}</td>
          <td>{{ produto.nome }}</td>
          <td style="width: 130px">{{ produto.grupo?.nome || '-' }}</td>
          <td style="width: 130px">{{ produto.subGrupo?.nome || '-' }}</td>
          <td style="width: 120px">{{ produto.saldo }}</td>
          <td style="width: 130px">{{ formatarValorMonetario(produto.custo) }}</td>
          <td style="width: 130px">{{ formatarValorMonetario(produto.precoDeVenda) }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="text-center p-4 text-500">
            {{ 'produto-selecionar.texts.nenhum_produto_encontrado' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Rodapé da tabela -->
  <div class="ps-tabela-footer">
    <span class="ps-registros-info">
      {{ firstRecord }}-{{ lastRecord }} / {{ totalRecords }}
    </span>
    <div class="ps-footer-actions">
      <button pButton
        [label]="('produto-selecionar.buttons.cancelar' | translate) + ' (Esc)'"
        class="p-button-text p-button-secondary"
        (click)="fecharTabelaBusca()"></button>
      <button pButton icon="pi pi-check"
        [label]="('produto-selecionar.buttons.selecionar' | translate) + ' (Enter)'"
        class="p-button-primary"
        [disabled]="!itemSelecionadoTabela"
        (click)="confirmarSelecaoTabela()"></button>
    </div>
  </div>
</div>

<!-- Formulário principal (visivel quando a tabela NAO esta aberta) -->
<div *ngIf="!mostrarTabelaBusca">

  <!-- Campo de selecao de produto com lupa -->
  <div class="ps-produto-input-container">
    <label class="ps-produto-label">
      <i class="pi pi-box" style="margin-right: 6px; color: #6366f1;"></i>
      {{ 'produto-selecionar.labels.produto' | translate }}
      <span class="text-red-500">*</span>
    </label>
    <div class="ps-produto-input-wrapper">
      <div class="ps-produto-input-display" (click)="abrirTabelaBusca()">
        <span *ngIf="!itemSelected?.id" class="ps-produto-placeholder">
          {{ 'produto-selecionar.placeholders.clique_para_selecionar_produto' | translate }}
        </span>
        <span *ngIf="itemSelected?.id" class="ps-produto-selected-text">
          {{ itemSelected.nome }}
          <span class="ps-produto-codigo">({{ 'produto-selecionar.labels.codigo' | translate }}: {{ itemSelected.codigoItem }})</span>
        </span>
        <i class="pi pi-search ps-lupa-icon"></i>
      </div>
      <button pButton type="button" icon="pi pi-plus" class="p-button-success ps-criar-btn"
        label="{{ 'produto-selecionar.tooltips.criar_novo_item' | translate }}"
        (click)="abrirDialogCriarItem()"></button>
      <button *ngIf="itemSelected?.id && !isEditMode" pButton type="button" icon="pi pi-times"
        class="p-button-text p-button-danger p-button-sm ps-limpar-btn"
        pTooltip="{{ 'produto-selecionar.tooltips.trocar_item' | translate }}"
        (click)="voltarParaTabela()"></button>
    </div>
  </div>

  <!-- Item selecionado - todas as fotos lado a lado (faixa; GET lazy ao selecionar) -->
  <div *ngIf="itemSelected?.id" class="ps-item-selecionado">
    <app-item-imagens-carrossel
      class="product-carousel-selected"
      [modoFaixa]="true"
      [itemId]="itemSelected.id"
      [imagemPrincipalUrl]="itemSelected.imagem"
      [idEmpresa]="idEmpresa"
      [alt]="itemSelected.nome">
    </app-item-imagens-carrossel>
  </div>

  <!-- Codigo de barras e nome (readonly, so aparece se tiver barras) -->
  <div class="ps-row" *ngIf="itemSelected?.barras" style="margin-top: 12px;">
    <div class="ps-form-group">
      <label class="ps-label">{{ 'produto-selecionar.labels.codigo_de_barras' | translate }}</label>
      <input pInputText [disabled]="true" class="disabled-input" [(ngModel)]="itemSelected.barras" />
    </div>
    <div class="ps-form-group">
      <label class="ps-label">{{ 'produto-selecionar.labels.nome_item' | translate }}</label>
      <input pInputText [disabled]="true" class="disabled-input" [(ngModel)]="itemSelected.nome" />
    </div>
  </div>

  <!-- Cards lado a lado: Dados da Compra + Referencia de Precos -->
  <div class="grid" style="margin-top: 12px;">

    <!-- Secao: Dados da Compra -->
    <div class="col-12 md:col-6">
      <div class="ps-section" style="margin-top: 0; height: 100%;">
        <div class="ps-section-header">
          <i class="pi pi-shopping-cart ps-section-icon"></i>
          <span class="ps-section-title">{{ 'produto-selecionar.blocks.dados_da_compra' | translate }}</span>
        </div>
        <div class="ps-section-content">

          <!-- Quantidade -->
          <div class="ps-row">
            <div class="ps-form-group">
              <label class="ps-label">{{ 'produto-selecionar.labels.quantidade' | translate }} <span class="text-red-500">*</span></label>
              <app-input-quantidade [(ngModel)]="form.itemDeNotaDTO.quantidade"
                [casasDecimais]="casasDecimaisQuantidade"
                [disabled]="!(itemSelected && itemSelected.id)"
                [style]="{ 'width': '100%' }"></app-input-quantidade>
            </div>
          </div>

          <!-- Valor total -->
          <div class="ps-row">
            <div class="ps-form-group">
              <label class="ps-label">{{ 'produto-selecionar.labels.valor_total' | translate }}</label>
              <div class="currency-input-container">
                <p-inputNumber [(ngModel)]="form.itemDeNotaDTO.valorTotal" [currency]="currencyCode" [locale]="locale"
                  [minFractionDigits]="casasDecimaisDaMoeda" [maxFractionDigits]="casasDecimaisDaMoeda"
                  [monetaryMask]="casasDecimaisDaMoeda" [disabled]="!(itemSelected && itemSelected.id)"
                  [style]="{ 'width': '100%' }"
                  inputStyleClass="currency-input-with-symbol"
                  [ngClass]="{ 'disabled-input': !(itemSelected && itemSelected.id) }">
                </p-inputNumber>
                <span class="currency-symbol-inside-input" *ngIf="moedaPadraoSimbolo" aria-hidden="true">{{ moedaPadraoSimbolo }}</span>
              </div>
            </div>
          </div>

          <!-- Valor unitario (calculado automaticamente) -->
          <div class="ps-row">
            <div class="ps-form-group">
              <label class="ps-label ps-label-readonly">
                <i class="pi pi-calculator ps-label-icon"></i>
                {{ 'produto-selecionar.labels.valor_unitario' | translate }}
                <span class="ps-label-hint">({{ 'produto-selecionar.labels.calculado_automaticamente' | translate }})</span>
              </label>
              <div class="currency-input-container">
                <p-inputNumber [disabled]="true" class="disabled-input" [currency]="currencyCode"
                  [locale]="locale" [(ngModel)]="valorTotal"
                  [minFractionDigits]="casasDecimaisDaMoeda" [maxFractionDigits]="casasDecimaisDaMoeda"
                  [monetaryMask]="casasDecimaisDaMoeda"
                  [style]="{ 'width': '100%' }"
                  inputStyleClass="currency-input-with-symbol">
                </p-inputNumber>
                <span class="currency-symbol-inside-input" *ngIf="moedaPadraoSimbolo" aria-hidden="true">{{ moedaPadraoSimbolo }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Secao: Referencia de Precos -->
    <div class="col-12 md:col-6">
      <div class="ps-section ps-section-reference" style="margin-top: 0; height: 100%;">
        <div class="ps-section-header ps-section-header-reference">
          <i class="pi pi-chart-line ps-section-icon"></i>
          <span class="ps-section-title">{{ 'produto-selecionar.blocks.referencia_de_precos' | translate }}</span>
        </div>
        <div class="ps-section-content">

          <!-- Custo anterior -->
          <div class="ps-row">
            <div class="ps-form-group">
              <label class="ps-label ps-label-readonly">{{ 'produto-selecionar.labels.custo_anterior' | translate }}</label>
              <div class="currency-input-container">
                <p-inputNumber [disabled]="true" class="disabled-input" [currency]="currencyCode"
                  [locale]="locale" [ngModel]="(itemSelected && itemSelected.custo) || 0"
                  [minFractionDigits]="casasDecimaisDaMoeda" [maxFractionDigits]="casasDecimaisDaMoeda"
                  [monetaryMask]="casasDecimaisDaMoeda"
                  [style]="{ 'width': '100%' }"
                  inputStyleClass="currency-input-with-symbol">
                </p-inputNumber>
                <span class="currency-symbol-inside-input" *ngIf="moedaPadraoSimbolo" aria-hidden="true">{{ moedaPadraoSimbolo }}</span>
              </div>
            </div>
          </div>

          <!-- Preco de venda atual -->
          <div class="ps-row">
            <div class="ps-form-group">
              <label class="ps-label ps-label-readonly">{{ 'produto-selecionar.labels.preco_de_venda_atual' | translate }}</label>
              <div class="currency-input-container">
                <p-inputNumber [disabled]="true" class="disabled-input" [currency]="currencyCode"
                  [locale]="locale" [ngModel]="(itemSelected && itemSelected.precoDeVenda) || 0"
                  [minFractionDigits]="casasDecimaisDaMoeda" [maxFractionDigits]="casasDecimaisDaMoeda"
                  [monetaryMask]="casasDecimaisDaMoeda"
                  [style]="{ 'width': '100%' }"
                  inputStyleClass="currency-input-with-symbol">
                </p-inputNumber>
                <span class="currency-symbol-inside-input" *ngIf="moedaPadraoSimbolo" aria-hidden="true">{{ moedaPadraoSimbolo }}</span>
              </div>
            </div>
          </div>

          <!-- Novo preco de venda (editavel) -->
          <div class="ps-row">
            <div class="ps-form-group">
              <label class="ps-label">{{ 'produto-selecionar.labels.novo_preco_de_venda' | translate }}</label>
              <div class="currency-input-container">
                <p-inputNumber [(ngModel)]="form.itemDeNotaDTO.novoPrecoVenda" [currency]="currencyCode" [locale]="locale"
                  [useGrouping]="true"
                  [minFractionDigits]="casasDecimaisDaMoeda" [maxFractionDigits]="casasDecimaisDaMoeda"
                  [monetaryMask]="casasDecimaisDaMoeda" [disabled]="!(itemSelected && itemSelected.id)"
                  [style]="{ 'width': '100%' }"
                  inputStyleClass="currency-input-with-symbol"
                  [ngClass]="{ 'disabled-input': !(itemSelected && itemSelected.id) }">
                </p-inputNumber>
                <span class="currency-symbol-inside-input" *ngIf="moedaPadraoSimbolo" aria-hidden="true">{{ moedaPadraoSimbolo }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="ps-footer">
    <div class="ps-footer-buttons">
      <button pButton label="{{ 'produto-selecionar.buttons.cancelar' | translate }} (Esc)" severity="secondary"
        (click)="closeDialog()"></button>

      <button *ngIf="isEditMode" pButton icon="pi pi-check"
        pTooltip="Ctrl+Enter"
        label="{{ 'produto-selecionar.buttons.atualizar_item' | translate }} (Ctrl+Enter)"
        (click)="atualizar()"></button>

      <button *ngIf="!isEditMode" pButton icon="pi pi-plus"
        pTooltip="Ctrl+Enter"
        label="{{ 'produto-selecionar.buttons.adicionar_item' | translate }} (Ctrl+Enter)"
        (click)="selecionar()"></button>
    </div>
  </div>
</div>

<!-- Dialog de criacao rapida de item.
     EXTRAIDO para `app-item-criar-rapido` (shared/components) para ser
     reaproveitado pela aba "Nova venda" do Operar Cliente. O comportamento da
     COMPRA e preservado: a pre-condicao "escolha o fornecedor primeiro"
     continua em `abrirDialogCriarItem()` e o item criado e auto-selecionado no
     formulario pelo handler `(criado)`. -->
<app-item-criar-rapido
  [(visible)]="mostrarDialogCriarItem"
  [fornecedorId]="pessoaId"
  (criado)="onNovoItemCriado($event)">
</app-item-criar-rapido>

<p-confirmDialog #cd>
  <ng-template pTemplate="headless" let-message>
    <div class="flex flex-column align-items-center p-5 surface-overlay border-round">
      <div class="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem">
        <i class="pi pi-exclamation-triangle text-5xl"></i>
      </div>
      <span class="font-bold text-2xl block mb-2 mt-4">{{ message.header }}</span>
      <p class="mb-0">{{ message.message }}</p>
      <div class="flex align-items-center gap-2 mt-4">
        <button pButton label="{{ 'produto-selecionar.buttons.confirmar' | translate }}" (click)="cd.accept()"
          class="w-8rem"></button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
